import { useState } from 'react';
import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import LayoutAuth from '../LayoutAuth';
import PasswordRecoveryBody, { Status } from './PasswordRecoveryBody';
import { SupportedResources } from '@/dataProvider/tools';
import { useResourceRegister } from '@/utils/resourceRegister';
import { useLocation } from 'react-router-dom';
import LayoutPlain from '../LayoutPlain';
import { RstPassCollect, RstPassCollectContext } from './PasswordRecoverySmsValidateBody';


const resource: SupportedResources = 'resetpassword'

const PasswordRecovery: FC = () => {
  useResourceRegister({ name: resource })
  const location = useLocation<any>()
  const initalEmail : string = (location.state ? location.state['email'] : '') ?? ''
  
  const [states, setStates] = useState({
    prevData: { email: initalEmail },
    stage: {
      email: initalEmail,
      otp: '',
      cid: '',
      nonce: '',
      newPass: '',
      confirmPass: '',
    },
    errors: {} as any,
    touched: {} as any,
    phoneNotAwailable: false,
    status: Status.Init
  })

  const ctxValue = {
    resource: 'restpassword-otp',
    getPayload: () => ({
      cid: states.stage.cid,
      nonce: states.stage.nonce,
      password: states.stage.newPass,
      confirmPassword: states.stage.confirmPass,
    }),
    extraOptions: {id: -1, record: {}}
  }

  return (
    states.status !== Status.CollectNewPass
    ? <LayoutAuth>
        <div role="main">
          <PasswordRecoveryBody states={states} setStates={setStates as any} />
        </div>
      </LayoutAuth>
    : <LayoutPlain>
        <Helmet>
          <title>Password Recovery | OnData</title>
        </Helmet>
        <RstPassCollectContext.Provider value={ctxValue}>
          <RstPassCollect states={states} setStates={setStates as any} />
        </RstPassCollectContext.Provider>
      </LayoutPlain>
  );
};

export default PasswordRecovery;
